import { ActionBase } from '../../../core/store/action/ActionBase';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';

export const EXPIRE_NOTIFICATION_ACTION = '[Configuration] Messages Expire Notification Action';

export class ExpireNotificationAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = EXPIRE_NOTIFICATION_ACTION;

  constructor(public payload: { notification: DateFramedMessageModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ExpireNotificationAction.ts